
import './App.css';
import React from "react";
import BaseLayout from "./components/container/base_layout";
import PopDetail from "./components/popdetail";
import Wait from "./components/wait";
import SecondLayer from "./components/container/second_layer";
import UgSpatial from "./ug/ug_spatial";
import * as LF from "leaflet";
import Basemap from "./ug/basemap";
import jwt_decode from 'jwt-decode';
import {AuthorizationService} from "./service/v1/authorization";
import {ensureCsrfToken} from "./service/csrf";
import SelfRegistration from "./components/v1/authorization/self_registration";
import LandingPage from "./components/pane/landing_page";
import PopBig from "./components/popbig";
import SimpleDownloadModal from "./components/simple_download_modal";

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.usernameRef = React.createRef();
        this.passwordRef = React.createRef();
        this.downloadModalRef = React.createRef();
        this.state = {
            errorMessage: '',
        }
        this.errorTimeout = null;
        this.handleChange = this.handleChange.bind(this)
        this.login = this.login.bind(this)
        this.loadMap = this.loadMap.bind(this)
        this.getLoginErrorMessage = this.getLoginErrorMessage.bind(this)

    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    // login() {
    //     /* sessionStorage.setItem('login','yes')
    //      window.location.reload()*/

    //     let username = this.usernameRef.current.value
    //     let password = this.passwordRef.current.value

    //     console.log(username)
    //     console.log(password)

    //     if (username === '' || password === '') {
    //         alert('Empty Credential(s)')
    //         return
    //     }
    //     try {
    //         Wait.show('Login...')
    //         AuthorizationService.login({
    //             username: username,
    //             password: password
    //         }).then(r => {
    //             Wait.dismiss()
    //             try {
    //                 const refresh = r.data.refresh
    //                 const access = r.data.access

    //                 const decoded = jwt_decode(access);
    //                 console.log('HAPA : ' + decoded);
    //                 console.log(decoded);
    //                 console.log('HAPA ||');


    //                 sessionStorage.setItem('refresh', refresh)
    //                 sessionStorage.setItem('access', access)
    //                 sessionStorage.setItem('decoded', JSON.stringify(decoded))
    //                 sessionStorage.setItem('login', 'yes')

    //                 window.location.reload()

    //             } catch (e) {
    //                 console.log(e)
    //             }

    //         })
    //     } catch (e) {
    //         console.log(e)
    //     }

    // }
    getLoginErrorMessage(error){
        if(!error){
            return 'Unable to complete login. Please try again.'
        }
        if(error.response){
            const status = error.response.status
            const detail = error.response.data?.detail
            if(status === 423){
                return detail || 'Account locked due to repeated failed logins. Please try again later.'
            }
            if(status === 400 || status === 401){
                return detail || 'Wrong username or password, please try again.'
            }
            if(status === 403){
                return 'Request blocked by CSRF protection. Refresh the page and try again.'
            }
            return detail || 'Login failed. Please try again.'
        }
        if(error.request){
            return 'No response from server. Check your connection and retry.'
        }
        return error.message || 'Login failed. Please try again.'
    }

    clearErrorTimeout = () => {
        if (this.errorTimeout) {
            clearTimeout(this.errorTimeout)
            this.errorTimeout = null
        }
    }

    clearLoginError = () => {
        this.clearErrorTimeout()
        if (this.state.errorMessage) {
            this.setState({errorMessage: ''})
        }
    }

    setLoginError = (message) => {
        if (!message) {
            this.clearLoginError()
            return
        }
        this.clearErrorTimeout()
        this.setState({errorMessage: message}, () => {
            this.errorTimeout = setTimeout(() => {
                this.setState({errorMessage: ''})
                this.errorTimeout = null
            }, 5000)
        })
    }

    async login() {
        let username = this.usernameRef.current.value
        let password = this.passwordRef.current.value
    
        console.log(username)
        console.log(password)
    
        if (username === '' || password === '') {
            alert('Empty Credential(s)')
            return
        }
        try {
            Wait.show('Login...')
            this.clearLoginError()
            try {
                await ensureCsrfToken()
            } catch (csrfError) {
                console.warn('Unable to prefetch CSRF token, continuing without it', csrfError)
            }
            AuthorizationService.login({
                username: username,
                password: password
            }).then(r => {
                Wait.dismiss()
                try {
                    const refresh = r.data.refresh
                    const access = r.data.access
    
                    const decoded = jwt_decode(access);
                    console.log('HAPA : ' + decoded);
                    console.log(decoded);
                    console.log('HAPA ||');
    
                    sessionStorage.setItem('refresh', refresh)
                    sessionStorage.setItem('access', access)
                    sessionStorage.setItem('decoded', JSON.stringify(decoded))
                    sessionStorage.setItem('login', 'yes')
                    sessionStorage.setItem('username', decoded.username || username)
                    this.clearLoginError()
    
                    window.location.reload()
    
                } catch (e) {
                    console.log(e)
                    const message = this.getLoginErrorMessage(e)
                    this.setLoginError(message)
                }
            }).catch(error => {
                Wait.dismiss()
                const message = this.getLoginErrorMessage(error)
                this.setLoginError(message)
                console.log(error)
            })
        } catch (e) {
            Wait.dismiss()
            const message = this.getLoginErrorMessage(e)
            this.setLoginError(message)
            console.log(e)
        }
    }


    registration() {
        PopDetail.showDynamic("Stakeholder Self Registration", <SelfRegistration/>, 75, 50)
    }

    render() {
        console.log('IMOOOOO')
        const decoded = sessionStorage.getItem('decoded')
        if (decoded) {
            let userGroups = JSON.parse(sessionStorage.getItem('decoded')).groups
            console.log('IMO')
            console.log(userGroups[0].name)
            sessionStorage.setItem('user_groups', userGroups[0].name)
        }
        return (<div>

            {sessionStorage.getItem('login') === 'yes' ?

                <div>
                    <BaseLayout/>
                    <SecondLayer/>
                </div> :

                <div className={'login-page'}>
                    <div className={'row'} style={{zIndex: 1000}}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            zIndex: 1000,
                            right: 0,
                            left: 0,
                            backgroundColor: '#395d9a'
                        }}
                             className={'base-toolbar'}>
                            <div style={{fontSize: '30px', float: 'left'}}>
                                {/*National Land Use Information System*/}
                            </div>
                            <div className={'login-toolbar-actions'} style={{float: 'right'}}>
                                <div className={'login-controls'}>
                                    <input name={'username'} defaultValue={this.state.username} placeholder={'Username'}
                                           type={'text'} /*onChange={this.handleChange} */ ref={this.usernameRef}/>
                                    <input name={'password'} defaultValue={this.state.password} placeholder={'Password'}
                                           type={'password'} /*onChange={this.handleChange} */ ref={this.passwordRef}/>
                                    <button className={'btn submit'} onClick={this.login}>
                                        <span className={'fa fa-sign-in'}/>Login
                                    </button>
                                    <button className={'btn submit'} onClick={this.registration}>
                                        <span className={'fa fa-user-circle'}/>Sign Up
                                    </button>
                                </div>
                                {this.state.errorMessage && (
                                    <div className={'login-error-alert'}>
                                        <span>{this.state.errorMessage}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <LandingPage key={new Date().getMilliseconds()}/>

                </div>}
            <PopDetail/>
            <PopBig/>
            <SimpleDownloadModal ref={this.downloadModalRef}/>

            <Wait/>
        </div>);
    }

    componentDidMount() {
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, document.title, window.location.href);
        });

        // Make download modal globally available
        if (this.downloadModalRef.current) {
            window.DownloadProgressModal = this.downloadModalRef.current;
        }

        if (sessionStorage.getItem('login') !== 'yes') {
            //this.loadMap()
        }
    }

    componentDidUpdate() {
        // Ensure download modal is globally available
        if (this.downloadModalRef.current && !window.DownloadProgressModal) {
            window.DownloadProgressModal = this.downloadModalRef.current;
        }
    }

    componentWillUnmount() {
        this.clearErrorTimeout()
    }

    loadMap() {
        UgSpatial.clear()
        let self = this
        let ly_labels = new LF.FeatureGroup(),
            ly_beacons = new LF.FeatureGroup(),
            ly_plots = new LF.FeatureGroup()
        let sat = Basemap.googleSat(),
            hybrid = Basemap.googleHybrid(),
            gray = Basemap.backWhite(),
            blank = LF.tileLayer('')

        let map = UgSpatial.map == null ? LF.map('map', {
            layers: [gray, ly_plots, ly_labels],
            attributionControl: false,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: 'topleft'
            },
            maxZoom: 10000
        }).setView([-6.085936, 35.711995], 7.5) : UgSpatial.map


        let baseLayers = {
            'Gray': gray,
            "<span style='color: gray'>Blank</span>": blank,
            "Satellite": sat,
            "Hybrid": hybrid
        }


        /*let overlays = {
            'Village Land Use':ly_group,
            'Regional Land Use':ly_features,
            'Zonal Land Use':ly_features,
            'National Land Use':ly_features,
            'CCRO':ly_features,
            'Village Boundaries':ly_features,
            'Conceptial Diagrams':ly_features,
            'Others':ly_features
        }*/
        let filter = '1=1'
        let layername = 'deed_plan'

        let selected = ''

        /*

                Wait.show("Loading Spatial...")
                api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
                    Wait.dismiss()
                    try {
                                //console.log(r.data)
                                r.data.features.forEach(p=>{

                                    let myLayer = LF.geoJSON(p,{
                                        onEachFeature:(f,l)=>{
                                            LF.marker(l.getBounds().getCenter(),{
                                                icon:LF.divIcon({
                                                    className:'bindTooltipBig',
                                                    html:f.properties.claim_no,
                                                    iconSize:[100,40]
                                                })
                                            }).addTo(ly_labels)
                                            l.setStyle({
                                                color:f.properties.status==='occupied'?'#000':'#f80',
                                                fillColor:f.properties.status==='occupied'?'#000':'#f80',
                                                 fillOpacity: f.properties.status==='occupied'?0.4:0,
                                            })
                                        },
                                        coordsToLatLng: function (coords) {
                                            return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                        },
                                        weight:3,zIndex:2,

                                    }).on('dblclick',e=>{


                                    }).on('click', function (e) {

                                        if (e.layer.feature.properties.status==="occupied"){
                                            alert('Occupied')
                                            return
                                        }
                                        //if (selected) {e.target.resetStyle(selected)}
                                        selected = e.layer


                                        let arr = self.state.selected_plots
                                        let new_arr = self.state.selected_plots
                                        let description = self.state.description
                                        let new_desr = self.state.description

                                        let id = parseInt(e.layer.feature.id.split('.')[1])
                                        let claim = e.layer.feature.properties.claim_no

                                        if (arr.includes(id)){
                                            new_arr = []
                                            new_desr = []
                                            arr.forEach(it=>{
                                                if (it!==id){
                                                    new_arr.push(it)
                                                }
                                            })
                                            description.forEach(it=>{
                                                if (it!==claim){
                                                    new_desr.push(claim)
                                                }
                                            })
                                            selected.setStyle({color: '#f80', weight:4})
                                        }else{
                                            selected.setStyle({color: '#00f', weight:4})
                                            map.fitBounds(selected.getBounds())
                                            new_arr.push(id)
                                            new_desr.push(claim)
                                        }

                                        self.setState({
                                            selected_plots:new_arr,
                                            description:new_desr
                                        })

                                        selected.bringToFront()

                                    })
                                    myLayer.addTo(ly_plots)
                                })
                                let myLayer = LF.geoJSON(r.data,{coordsToLatLng: function (coords) {return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();}})
                                //try{ map.fitBounds(myLayer.getBounds())}catch (e) { }
                            }catch (e){
                                console.log(e)
                            }
                })


                layername = 'point_spatial'
                api.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson').then(r=>{
                    Wait.dismiss()
                    try {
                                ///console.log(r.data)
                                r.data.features.forEach(p=>{
                                    let myLayer = LF.geoJSON(p,{
                                        onEachFeature:(f,l)=>{
                                            //console.log(l._latlng)
                                            LF.marker(l._latlng,{
                                                icon:LF.divIcon({
                                                    className:'bindTooltipBig',
                                                    html:f.properties.description,
                                                    iconSize:[100,40]
                                                })
                                            }).addTo(ly_beacons)
                                           /!* l.setStyle({
                                                color:f.properties.status==='Approved'?'#00ff00':'#901'
                                            })*!/
                                        },
                                        coordsToLatLng: function (coords) {
                                            return LF.utm({x: coords[0], y: coords[1], zone: 36, band: 'M'}).latLng();
                                        },
                                        weight:3,zIndex:2, fillOpacity: 0
                                    }).on('dblclick',e=>{


                                    }).on('click', function (e) {


                                    })
                                    //myLayer.addTo(ly_group)
                                })
                            }catch (e){
                                console.log(e)
                            }
                })
        */


        let overlays = {
            'Plots': ly_plots,
            'Labels': ly_labels,
            'Beacons': ly_beacons,

        }


        UgSpatial.layers = LF.control.layers(baseLayers, overlays, {position: 'bottomleft'}).addTo(map)

        this.setState({
            selected_plots: [],
            description: []
        })
    }

}





